export default "__VITE_ASSET__BRxxyKwB__"